import i18next from 'i18next';

// eslint-disable-next-line max-len
const emailDomainPattern = /([a-z0-9][a-z0-9-]{0,61}[a-z0-9]\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i;
const appDomainPattern = /([a-z0-9][a-z0-9-]{0,61}[a-z0-9]\.)*[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i;

export const isEmailDomainValid = (value) => {
  const result = emailDomainPattern.exec(value);
  return (result && result[0] === value) || false;
};

export const emailDomainValidator = (rule, value) =>
  new Promise((resolve, reject) => {
    if (!value) {
      resolve();
    } else if (isEmailDomainValid(value)) {
      resolve();
    } else {
      reject(i18next.t('profileInputs.emailDomain.formatError'));
    }
  });

export const applicationDomainValidator = (rule, value) =>
  new Promise((resolve, reject) => {
    if (!value) {
      resolve();
    } else if (isEmailDomainValid(value)) {
      resolve();
    } else {
      reject(i18next.t('profileInputs.customAppDomain.formatError'));
    }
  });

export const isCustomAppDomainValid = (value) => {
  const result = appDomainPattern.exec(value);
  return (result && result[0] === value) || false;
};

export const customAppDomainValidator = (rule, value) =>
  new Promise((resolve, reject) => {
    if (!value) {
      resolve();
    } else if (isCustomAppDomainValid(value)) {
      resolve();
    } else {
      reject(i18next.t('appDomainInput.formatError'));
    }
  });

const beginCertificate = '-----BEGIN CERTIFICATE-----';
const endCertificate = '-----END CERTIFICATE-----';

const certHasBothTags = (certificate) =>
  certificate.includes(beginCertificate) && certificate.includes(endCertificate);
const certHasNoTags = (certificate) =>
  !certificate.includes(beginCertificate) && !certificate.includes(endCertificate);

const certHasNoTextBeforeTags = (certificate) => {
  const beforeBegin = certificate.split(beginCertificate)[0];
  const afterEnd = certificate.split(endCertificate)[1];

  return !beforeBegin && !afterEnd;
};

export const isCertificateValid = (value) => {
  if (!value) {
    return true;
  }

  const hasBothTags = certHasBothTags(value);
  const hasNoTags = certHasNoTags(value);
  const hasNoTextBeforeTags = hasBothTags ? certHasNoTextBeforeTags(value) : true;

  return hasNoTags || (hasBothTags && hasNoTextBeforeTags);
};

export const certificateValidator = (rule, value) =>
  new Promise((resolve, reject) => {
    if (!value) {
      resolve();
    } else if (isCertificateValid(value)) {
      resolve();
    } else {
      reject(i18next.t('profileInputs.certificate.formatError'));
    }
  });

export const trimCertificate = (value) => {
  if (!value) {
    return value;
  }

  return value.trim();
};
